import React, { useState } from "react";
import styled from "styled-components";
import CloseIcon from "@material-ui/icons/Close";
import { useSelector } from "react-redux";

const Header = () => {
  const [burgerStatus, setBurgerStatus] = useState(false);
  const cars = useSelector((state) => state.car.cars);
  console.log(cars);
  return (
    <>
      <Navigation>
        <Logo src="/images/logo.svg"></Logo>
        <Nav>
          <ul>
            {cars.map((item, index) => (
              <li key={index}>
                <a href={`#${item.link}`}>{item.name}</a>
              </li>
            ))}
          </ul>
        </Nav>
        <RightNav>
          <ul>
            <li>
              <a href="#">Shop</a>
            </li>
            <li>
              <a href="#">Account</a>
            </li>
            <li onClick={() => setBurgerStatus(true)}>
              <a href="#">Menu</a>
            </li>
          </ul>
        </RightNav>
      </Navigation>
      <HiddenMenu show={burgerStatus}>
        <Cross onClick={() => setBurgerStatus(false)}>
          <CloseIcon className="cross-icon" />
        </Cross>
        <ul>
          {cars.map((item, index) => (
            <li key={index}>
              <a href={`#${item.link}`}>{item.name}</a>
            </li>
          ))}
          <li>
            <a href="#">Existing Inventory</a>
          </li>
          <li>
            <a href="#">Used Inventory</a>
          </li>
          <li>
            <a href="#">Trade-In</a>
          </li>
          <li>
            <a href="#">Test Drive</a>
          </li>
          <li>
            <a href="#">Insurance</a>
          </li>
          <li>
            <a href="#">Cybertruck</a>
          </li>
        </ul>
      </HiddenMenu>
    </>
  );
};

export default Header;

const Navigation = styled.div`
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  display: flex;
  justify-content: space-between;
  padding: 20px;
  z-index: 10;
`;

const Logo = styled.img``;

const Nav = styled.div`
  ul {
    list-style-type: none;
    display: flex;
  }
  ul > li > a {
    padding: 0px 5px;
    margin: 0px 5px;
    border-radius: 10px;
    cursor: pointer;
    text-decoration: none;
  }
  ul > li > a:hover {
    background-color: #e9e9e973;
    border-radius: 10px;
    // transition: all 0.7s;
  }
  @media (max-width: 786px) {
    display: none;
  }
`;

const RightNav = styled.div`
  ul {
    list-style-type: none;
    display: flex;
  }
  ul > li > a {
    text-decoration: none;
    padding: 0px 5px;
    margin: 0px 5px;
    border-radius: 10px;
    cursor: pointer;
  }
  ul > li > a:hover {
    background-color: #e9e9e973;
    cursor: pointer;
    border-radius: 10px;
    transition: all 0.5s;
  }
`;

const HiddenMenu = styled.div`
  width: 300px;
  height: 100vh;
  position: fixed;
  background-color: white;
  padding: 30px;
  padding-top: 10px;
  right: 0px;
  z-index: 100;
  overflow-x: auto;
  transform: ${(props) => (props.show ? "translateX(0)" : "translateX(100%)")};
  transition: all 0.5s;
  ul {
    list-style-type: none;
    margin: 15px 0px;
  }
  ul > li {
    text-align: left;
    padding: 5px 10px;
    cursor: pointer;
    border-radius: 20px;
    transition: all 0.5s;
    margin: 10px;
  }
  ul > li:hover {
    background-color: #e9e9e973;
  }
`;

const Cross = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .cross-icon {
    width: 35px;
    transition: all 0.5s;
    height: 35px;
    border-radius: 30px;
    cursor: pointer;
  }
  .cross-icon:hover {
    background-color: #e9e9e973;
  }
`;
